import React, { useEffect } from 'react';

const SalsaAtThePark = () => {
  useEffect(() => {
    // Add interactive sparkle effects
    const sparkles = document.querySelectorAll('.sparkle');
    
    const handleMouseEnter = function() {
      this.style.transform = 'scale(1.5) rotate(180deg)';
      this.style.transition = 'all 0.3s ease';
    };
    
    const handleMouseLeave = function() {
      this.style.transform = 'scale(1) rotate(0deg)';
    };
    
    sparkles.forEach(sparkle => {
      sparkle.addEventListener('mouseenter', handleMouseEnter);
      sparkle.addEventListener('mouseleave', handleMouseLeave);
    });

    // Cleanup event listeners
    return () => {
      sparkles.forEach(sparkle => {
        sparkle.removeEventListener('mouseenter', handleMouseEnter);
        sparkle.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-200 via-yellow-100 to-orange-200">
      <style jsx>{`
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .hero {
          background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%);
          border-radius: 20px;
          padding: 40px;
          margin-bottom: 30px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.2);
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,193,7,0.1) 0%, transparent 70%);
        }

        .hero-content {
          position: relative;
          z-index: 2;
        }

        .title {
          font-size: 3.5rem;
          font-weight: bold;
          color: #2c3e50;
          text-align: center;
          margin-bottom: 20px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
          letter-spacing: 2px;
        }

        .subtitle {
          font-size: 1.5rem;
          color: #34495e;
          text-align: center;
          margin-bottom: 40px;
          font-weight: 300;
        }

        .event-details {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-top: 40px;
        }

        .detail-card {
          background: rgba(255,255,255,0.8);
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          border: 1px solid rgba(255,255,255,0.3);
          backdrop-filter: blur(5px);
        }

        .detail-card h3 {
          color: #e74c3c;
          font-size: 1.5rem;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .detail-card p {
          font-size: 1.1rem;
          color: #2c3e50;
          margin-bottom: 10px;
        }

        .location-card {
          background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
          color: white;
        }

        .location-card h3 {
          color: white;
        }

        .highlights {
          background: rgba(255,255,255,0.9);
          border-radius: 15px;
          padding: 30px;
          margin-top: 30px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }

        .highlights h3 {
          color: #e74c3c;
          font-size: 1.8rem;
          margin-bottom: 20px;
          text-align: center;
        }

        .highlight-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }

        .highlight-item {
          background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
          color: white;
          padding: 20px;
          border-radius: 10px;
          text-align: center;
          font-weight: 500;
          transition: transform 0.3s ease;
        }

        .highlight-item:hover {
          transform: scale(1.05);
        }

        .cta-section {
          text-align: center;
          margin-top: 40px;
          padding: 40px;
          background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
          border-radius: 15px;
          color: white;
        }

        .cta-section h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
        }

        .cta-section p {
          font-size: 1.3rem;
          margin-bottom: 30px;
        }

        .dance-emoji {
          font-size: 2rem;
        }

        .icon {
          font-size: 1.5rem;
        }

        @media (max-width: 768px) {
          .title {
            font-size: 2.5rem;
          }
          
          .hero {
            padding: 20px;
          }
          
          .detail-card {
            padding: 20px;
          }
        }

        .sparkle {
          display: inline-block;
          color: #ffd700;
          animation: sparkle 1.5s ease-in-out infinite alternate;
        }

        @keyframes sparkle {
          0% { opacity: 0.4; transform: scale(0.8); }
          100% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>

      <div className="container">
        <div className="hero">
          <div className="hero-content">
            <h1 className="title">
              <span className="sparkle">✨</span> 
              SALSA AT THE PARK 
              <span className="sparkle">✨</span>
            </h1>
            <p className="subtitle">Feel the rhythm and join a fun, diverse dance community!</p>
            
            <div className="event-details">
              <div className="detail-card">
                <h3><span className="icon">🕰️</span> Schedule</h3>
                <p><strong>Every Friday</strong><br />June 6 - July 11</p>
                <p><strong>7:00 - 7:30 PM</strong><br />Free Intro Salsa, Bachata & Merengue lesson</p>
                <p><strong>7:30 - 9:00 PM</strong><br />Social Dance for all levels</p>
              </div>
              
              <div className="detail-card location-card">
                <h3><span className="icon">📍</span> Location</h3>
                <p><strong>Sun Hop Park</strong></p>
                <p>3333 Main St, Vancouver, BC</p>
                <p>Perfect outdoor dance setting!</p>
              </div>
            </div>
          </div>
        </div>

        <div className="highlights">
          <h3>Why Join Us? <span className="dance-emoji">💃</span></h3>
          <div className="highlight-grid">
            <div className="highlight-item">
              <strong>Open to all levels</strong><br />
              Beginners welcome!
            </div>
            <div className="highlight-item">
              <strong>Partner optional</strong><br />
              Come solo or with friends
            </div>
            <div className="highlight-item">
              <strong>Perfect for first-timers</strong><br />
              Supportive community
            </div>
            <div className="highlight-item">
              <strong>100% Free</strong><br />
              Just come and dance!
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h2>Ready to Dance? <span className="dance-emoji">🕺</span></h2>
          <p>No experience needed - just bring your enthusiasm and comfortable shoes!</p>
          <p><strong>Every Friday from June 6th to July 11th</strong></p>
          <p>See you at Sun Hop Park for an evening of Latin rhythms and community fun!</p>
        </div>
      </div>
    </div>
  );
};

export default SalsaAtThePark;